import { render } from "./MainMenuOverlay.vue?vue&type=template&id=e20a6554"
import script from "./MainMenuOverlay.vue?vue&type=script&lang=ts"
export * from "./MainMenuOverlay.vue?vue&type=script&lang=ts"

import "./MainMenuOverlay.vue?vue&type=style&index=0&id=e20a6554&lang=scss"
script.render = render

export default script